import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import {
  IconDotsVertical,
  IconHelp,
  IconMapPin
} from 'angular-tabler-icons/icons';
import { MaterialModule } from '../material/material.module';
import { DialogAddOpIncidentComponent } from './dialog-add-op-incident/dialog-add-op-incident.component';
import { DialogDeleteOpIncidentComponent } from './dialog-delete-op-incident/dialog-delete-op-incident.component';
import { DialogIncidentHistoryComponent } from './dialog-incident-history/dialog-incident-history.component';
import { DialogUpdateOpIncidentComponent } from './dialog-update-op-incident/dialog-update-op-incident.component';
import { IncidenciasDashboardComponent } from './incidencias-dashboard/incidencias-dashboard.component';
import { IncidenciasRoutingModule } from './incidencias-routing.module';
import { IncidenciasComponent } from './incidencias.component';
import { DialogSelectServiceComponent } from './operativas/dialog-select-service/dialog-select-service.component';
import { OperativasComponent } from './operativas/operativas.component';
import { PreOperativasComponent } from './pre-operativas/pre-operativas.component';
import { RevisionAcComponent } from './revision-ac/revision-ac.component';

@NgModule({
  declarations: [
    IncidenciasComponent,
    OperativasComponent,
    DialogAddOpIncidentComponent,
    DialogUpdateOpIncidentComponent,
    IncidenciasDashboardComponent,
    PreOperativasComponent,
    RevisionAcComponent,
    DialogIncidentHistoryComponent,
    DialogDeleteOpIncidentComponent,
    DialogSelectServiceComponent
  ],
  imports: [
    CommonModule,
    TablerIconsModule.pick({ IconMapPin, IconHelp, IconDotsVertical }),
    MatSortModule,
    IncidenciasRoutingModule,
    RouterModule,
    MaterialModule,
    TextFieldModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class IncidenciasModule {}
